import { render } from "./ContainerIncomes.vue?vue&type=template&id=fbfccdfa"
import script from "./ContainerIncomes.vue?vue&type=script&lang=js"
export * from "./ContainerIncomes.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/components/dashboard/agro_exporter/container_incomes.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fdashboard%2Fagro_exporter%2FContainerIncomes.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__